import {useTranslation} from "@Translation/hooks/useTranslation";
import {multiModalTranslationKey} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import TipsPerTransportType from "@SearchResults/features/staticContent/components/TipsPerTransportType";
import Translation from "@Translation/components/Translation";
import Tip from "@SearchResults/features/staticContent/features/multiModal/features/tips/components/Tip";
import OperatorsList from "@SearchResults/features/staticContent/components/OperatorsList";
import getTravelTimes from "@SearchResults/features/staticContent/functions/getTravelTimes";
import RouteType from "@Route/types/Route.type";
import getMinMaxPriceForType from "@SearchResults/features/staticContent/functions/getMinMaxPriceForType";
import CompanyType from "@SearchResults/types/company/Company.type";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import getTranslationFromTransportType
    from "@SearchResults/features/staticContent/functions/getTranslationFromTransportType";

interface BusTipsContentProps {
    departure: string,
    destination: string,
    priciestVehClass: TransportTypesType,
    distanceLandMiles: string,
    companies: Record<string, CompanyType>
    routes: RouteType[],
    operators: string[],
}

function BusTipsContent(props: BusTipsContentProps) {
    const {
        departure,
        destination,
        priciestVehClass,
        distanceLandMiles,
        companies,
        routes,
        operators,
    } = props

    const priciestVehClassTranslation = getTranslationFromTransportType(priciestVehClass)

    const {min: cheapestPrice, cheapestCompanyId} = getMinMaxPriceForType(routes)
    const cheapestOperator = companies[cheapestCompanyId].name
    const {maxTime} = getTravelTimes(routes)

    const title = useTranslation(
        `${multiModalTranslationKey}.buses.title`,
        {departure, destination}
    )

    const description = useTranslation(
        `${multiModalTranslationKey}.buses.desc1`,
        {departure, destination, priciestVehClass: priciestVehClassTranslation}
    )

    return (
        <>
            <TitleAndContent
                title={title}
                content={description}
            />
            <TipsPerTransportType
                subtitle={(
                    <Translation translationKey={`${multiModalTranslationKey}.buses.trip_details.title`}/>
                )}
                options={[
                    {
                        id: "bus-o1",
                        option: (
                            <Tip
                                title={(
                                    <Translation
                                        translationKey={`${multiModalTranslationKey}.buses.trip_details.o1.title`}
                                    />
                                )}
                                description={(
                                    <Translation
                                        translationKey={`${multiModalTranslationKey}.buses.trip_details.o1.desc`}
                                        translationVariables={{distanceLandMiles}}
                                    />
                                )}
                            />
                        ),
                    },
                    {
                        id: "bus-o2",
                        option: (
                            <Tip
                                title={(
                                    <Translation
                                        translationKey={`${multiModalTranslationKey}.buses.trip_details.o2.title`}
                                    />
                                )}
                                description={(
                                    <Translation
                                        translationKey={`${multiModalTranslationKey}.buses.trip_details.o2.desc`}
                                        translationVariables={{cheapestPrice: `${cheapestPrice}EUR`, cheapestOperator}}
                                    />
                                )}
                            />
                        ),
                    },
                    {
                        id: "bus-o3",
                        option: (
                            <Tip
                                title={(
                                    <Translation
                                        translationKey={`${multiModalTranslationKey}.buses.trip_details.o3.title`}
                                    />
                                )}
                                description={(
                                    <Translation
                                        translationKey={`${multiModalTranslationKey}.buses.trip_details.o3.desc`}
                                        translationVariables={{durationMax: maxTime}}
                                    />
                                )}
                            />
                        ),
                    },
                ]}
            />
            <OperatorsList
                title={(
                    <Translation
                        translationKey={`${multiModalTranslationKey}.buses.operators_list.title`}
                        translationVariables={{departure, destination}}
                    />
                )}
                operators={operators}
            />
        </>
    )
}

export default BusTipsContent